import { Injectable, signal } from '@angular/core';

// Root-scoped so it outlives a single presentation: the modal (and its
// component instance) is destroyed and recreated on every open on hosts like
// recruitee-mobile (ModalController.create()), so a per-instance flag can
// never remember that the sheet was expanded in an earlier session. Once set,
// never resets to false for as long as the app is running.
@Injectable({ providedIn: 'root' })
export class TellentAssistantMobileExpandedStateService {
  public readonly expanded = signal(false);

  public markExpanded(): void {
    this.expanded.set(true);
  }
}
